module.exports = __webpack_public_path__ + "img/pause-preenchido.75aa93ac.svg";